import { render, staticRenderFns } from "./updateRecommendGood.vue?vue&type=template&id=02d9427a&scoped=true"
import script from "./updateRecommendGood.vue?vue&type=script&lang=js"
export * from "./updateRecommendGood.vue?vue&type=script&lang=js"
import style0 from "./updateRecommendGood.vue?vue&type=style&index=0&id=02d9427a&prod&lang=scss&scoped=true"
import style1 from "./updateRecommendGood.vue?vue&type=style&index=1&id=02d9427a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d9427a",
  null
  
)

export default component.exports